var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInternet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12C5.384 24 0 18.617 0 12S5.384 0 12 0zm-1 17H7.987A13.577 13.577 0 0011 21.555V17zm5.012 0H13v4.55A13.583 13.583 0 0016.012 17zm4.635 0h-2.488a15.584 15.584 0 01-2.184 4.172A10.052 10.052 0 0020.647 17zM5.84 17H3.353a10.051 10.051 0 004.668 4.169 15.543 15.543 0 01-2.181-4.17zm15.699-8h-2.847c.195.983.308 1.984.308 3s-.113 2.018-.31 3h2.849a9.95 9.95 0 00.46-3 9.95 9.95 0 00-.46-3zm-4.886 0H13v6h3.653A13.35 13.35 0 0017 12c0-1.018-.122-2.023-.347-3zM11 9H7.348A13.382 13.382 0 007 12.002c0 1.018.122 2.022.347 2.998H11V9zM5.309 9H2.46a9.98 9.98 0 000 6h2.847A15.432 15.432 0 015 12.002c0-1.017.114-2.02.309-3.002zm2.717-6.172A10.064 10.064 0 003.353 7h2.489a15.556 15.556 0 012.184-4.172zm7.95.002A15.598 15.598 0 0118.16 7h2.487a10.048 10.048 0 00-4.67-4.17zM11 2.45A13.582 13.582 0 007.989 7h3.01zm2-.003V7h3.013A13.623 13.623 0 0013 2.447z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconInternet;